import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import range from 'lodash/range';
import { BasicFormModal } from 'synapsefi-dev-ui';

const InputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const Input = styled.input`
  width: 70px;
  height: 70px;
  font-size: 46px;
  border: none;
  outline: none;
  border-radius: 6px;
  box-shadow:  0px 4px 10px rgba(0, 0, 0, 0.15);;
  text-align: center;
  color: #022d33;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const StyledBasicFormModal = styled(BasicFormModal)`
  margin-bottom: 0px;

  .syn-dev-ui-modal-header {
    height: 80px;
    padding: 0 40px;
  }

  .syn-dev-ui-modal-body {
    padding: 40px 40px 24px;
  }

  .syn-dev-ui-form-footer {
    margin-top: 38px;
  }

  .syn-dev-ui-basic-modal-form-footer {
    border-width: 0px;
    padding: 0px 40px 24px;
  }

  .syn-dev-ui-button-focus-container {
    padding: 3px 12px;
  }
`;

const ErrorMessage = styled.p`
  color: #FF5757;
  /* text-align: end; */
  margin: 0px;
`;

class PinModal extends React.Component {
  constructor(props) {
    super(props);
    this.textInput0 = React.createRef();
    this.textInput1 = React.createRef();
    this.textInput2 = React.createRef();
    this.textInput3 = React.createRef();

    this.state = {
      error: '' || props.error
    }
  }

  getCode = () => {
    return range(4).map((idx) => this[`textInput${idx}`].current.value).join('');
  }

  onVerify = () => {
    this.props.onSubmit(this.getCode());
  };

  onChange = (e) => {
    const { id } = e.target.dataset;
    const { onChange } = this.props;

    if (e.target.value) {
      if (onChange) onChange(e, this.getCode());
      this.next(id);
    }
  }

  next = (index) => {
    const fieldName = `textInput${Math.min(index, 2) + 1}`;
    this[fieldName].current.focus();

  };

  prev = (index) => {
    const fieldName = `textInput${Math.max(index, 1) - 1}`;
    this[fieldName].current.focus()
  };

  onPaste = (e) => {
    let codes = e.clipboardData.getData('Text');
    let codesArray = codes.split('');

    this.textInput0.current.value = codesArray[0];
    this.textInput1.current.value = codesArray[1];
    this.textInput2.current.value = codesArray[2];
    this.textInput3.current.value = codesArray[3];

    this.textInput3.current.focus();

    // if(!isNaN(codes) && codesArray.length === 6) {
    //   this.onVerify()
    // }
  }

  onKeyDown = (e) => {
    const { id } = e.target.dataset;

    if (e.keyCode === 8) {
      if (this.state.error) this.setState({ error: '' });
      this.prev(+id);
      e.target.value = '';
      e.preventDefault();
      return false;
    }

    if (e.keyCode === 13 && e.target.value.length > 0) {
      e.preventDefault();
      this.onVerify();
      this.props.closeModal();
    }
  }

  handleSubmit = (values, props) => {
    const error = this.onHandleValidation();

    if (error !== '') {
      this.setState({ error: 'Invalid PIN Number' });
      return;
    } else {
      const pinCode = this.getCode();
      this.props.closeModal();
      return this.props.onSubmit(pinCode)
    }
  };

  onHandleValidation = (values, props) => {
    const result = this.getCode();
    const isInteger = this.isNormalInteger(result);

    if (result.length < 4 || !isInteger) {
      return 'Invalid PIN Number'
    }
    return ''
  }

  isNormalInteger(str) {
    str = str.trim();
    if (!str) {
      return false;
    }
    str = str.replace(/^0+/, "") || "0";
    var n = Math.floor(Number(str));
    return n !== Infinity && String(n) === str && n >= 0;
  }

  render() {
    const { error } = this.state;
    const { isOpen, closeModal } = this.props;

    return (
      <StyledBasicFormModal
        width="426px"
        height="306px"
        // className="override-PIN-modal-content"
        headerText="PIN Number"
        isOpen={isOpen}
        closeModal={closeModal}
        initialState={() => ({})}
        formData={[]}
        handleSubmit={this.handleSubmit}
        buttonSettings={{
          cancelButton: {
            inlineBtnStyle: { display: 'none' }
          },
          submitButton: {
            size: 'small',
            inlineBtnStyle: { width: '92px' }
            // text: 'Submit'
          }
        }}
      >
        <React.Fragment>
          <InputWrapper>
            <Input maxLength={1} ref={this.textInput0} data-id={0} onChange={this.onChange} onKeyDown={this.onKeyDown} autoFocus onPaste={this.onPaste} />
            <Input maxLength={1} ref={this.textInput1} data-id={1} onChange={this.onChange} onKeyDown={this.onKeyDown} />
            <Input maxLength={1} ref={this.textInput2} data-id={2} onChange={this.onChange} onKeyDown={this.onKeyDown} />
            <Input maxLength={1} ref={this.textInput3} data-id={3} onChange={this.onChange} onKeyDown={this.onKeyDown} />
          </InputWrapper>
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </React.Fragment>
      </StyledBasicFormModal>
    );
  }
}

export default PinModal;